<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="5">
            <div class="search-form-label">样本册：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="样本册"
                clearable
                v-model="queryData.sampleName"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label">页码：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="页码"
                clearable
                v-model="queryData.pageCount"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label">类别：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="类别"
                clearable
                v-model="queryData.category"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label">笼号：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="笼号"
                clearable
                v-model="queryData.basketNo"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label">未出库：</div>
            <div class="search-form-controller">
              <el-checkbox
                size="mini"
                placeholder="未出库"
                clearable
                v-model="queryData.notOutStore"
              ></el-checkbox>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label">担当：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="担当"
                clearable
                v-model="queryData.undertake"
              ></el-input>
            </div>
          </el-col>
          <!-- <el-col :span="4">
            <div class="search-form-label">状态：</div>
            <div class="search-form-controller">
              <el-select size="mini" v-model="queryData.status" placeholder="请选择" style="margin-left:20px">
                <el-option v-for="item in statusDatas" :key="item.value" :label="item.value" :value="item.value"></el-option>
              </el-select>
            </div>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索
            </el-button>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空
            </el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
            >
              关闭搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}
          </el-button>
          <el-date-picker
            size="mini"
            v-model="dateValue"
            @change="dateChange(dateValue)"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="类别"
            prop="category"
            width="120"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            label="出/入库"
            prop="outInStore"
            width="120"
            align="center"
          ></el-table-column> -->
          <el-table-column
            label="样本册"
            prop="sampleName"
            width="170"
            align="center"
          ></el-table-column>
          <el-table-column
            label="先后"
            prop="fristBackName"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="页码"
            prop="pageCount"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="品番"
            prop="merchandiseNumber"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="笼号"
            prop="basketNo"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="单位1"
            prop="typeName1"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="单位2"
            prop="typeName2"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="包装产量"
            prop="number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="出勤日期"
            prop="attendanceDate"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="担当"
            prop="undertake"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库"
            prop="inStore"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="库位"
            prop="position"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="出库"
            prop="outStore"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="出库日期"
            prop="outstoreDate"
            width="120"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            label="员工"
            prop="employee"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="时间"
            prop="date"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            label="状态"
            prop="status"
            width="150"
            align="center"
          ></el-table-column> -->
          <el-table-column></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      ds: [],
      queryData: {
        category: "",
        pageCount: "",
        sampleName: "",
        basketNo: "",
        undertake:"",
        status: "",// 状态过滤已经停用 by dream 2022-12-11
        notOutStore:false,//增加是否未出库过滤 by dream 2022-12-11
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0, // 数据总条数
        dateValue: []
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      statusDatas:[{ value: "未出库" }, { value: "已出库" }],
      dateValue:[]
    };
  },
  beforeCreate: function () {
    let date = new Date()
    let month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    let day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day

    let preDate = new Date((date/1000-86400*10)*1000)
    let premonth = preDate.getMonth() < 9 ? '0' + (preDate.getMonth() + 1) : preDate.getMonth() + 1
    let preday = preDate.getDate() <= 9 ? '0' + preDate.getDate() : preDate.getDate()
    this.preDate10 = preDate.getFullYear() + '-' + premonth + '-' + preday
  },
  created: function() {},
  mounted: function() {
    this.queryData.dateValue.push(this.preDate10)
    this.queryData.dateValue.push(this.currentDate)
    this.dateValue.push(this.preDate10)
    this.dateValue.push(this.currentDate)
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getOutInStoreDetailList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    dateChange: function(dateValue) {
      this.queryData.dateValue = dateValue;
      this.loadData();
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.pageCount = "";
        this.queryData.category = "";
        this.queryData.sampleName = "";
        this.queryData.basketNo = "";
        this.queryData.status = "";
        this.queryData.undertake = "";
        // 清除时，需要清除复选框 by dream by 20221214
        this.queryData.notOutStore=false;
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    },
    // 导出excel
    exportHandler: function() {
      let _this = this;
      _this.post(
        _this.$apis.exportOutInList,
        _this.queryData,
        function(res) {
          let _json = res.data;
          if (_json.fileUrl !== "") {
            window.location = _this.$apiroot + _json.fileUrl;
          } else {
            _this.$router.push({
              path: "/"
            });
          }
        }
      );
    },
  },
  components: {}
};
</script>
